import { createLoginToken } from 'models';
import { useCallback } from 'react';
import { message } from 'ui';
import { getLoginToken, useUser } from 'features/auth';
import { routes } from '../routes';

export const generateAdminDashboardUrl = (path: string) => `${import.meta.env.VITE_APP_ADMIN_DASHBOARD_URL}${path}`;

export const useAdminDashboardRedirect = () => {
  const { railsUserData } = useUser();

  return useCallback(
    async (referrer: string) => {
      const adminUrl = new URL(generateAdminDashboardUrl(routes.tokenLogin));
      const userId = railsUserData.id;

      try {
        const response = await getLoginToken();
        const { loginToken } = createLoginToken(response.data);
        adminUrl.searchParams.append('login_token', loginToken);
        adminUrl.searchParams.append('referrer', referrer);
        adminUrl.searchParams.append('user_id', userId);
      } catch {
        message.error('Cannot generate link with login token');
      }

      return window.open(adminUrl.toString(), '_blank');
    },
    [railsUserData.id],
  );
};
